import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Hero = () => {
	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		pauseOnHover: false,
	};

	const images = [
		"/images/principles.png",
		"/images/principles.png",
		"/images/principles.png",
		"/images/principles.png",
		"/images/principles.png",
		"/images/principles.png",
	];

	return (
		<section className="flex justify-between lg:pl-10 bg-white">
			<div className="lg:max-w-xl w-1/2 z-10 p-6 pr-0 my-auto">
				<h1 className="lg:text-4xl text-base font-bold text-gray-800 mb-6 leading-snug">
					Welcome to <br /> Sri Seetha Rama Seva Sadan
				</h1>
				<p className="lg:text-lg text-xs leading-relaxed text-gray-600 text-justify">
					At Sri Seetha Rama Seva Sadan, we are committed to serving humanity
					through various welfare initiatives. From education to environmental
					preservation, we strive to make a meaningful impact in the community.
				</p>
			</div>
			<div className="relative lg:w-3/5 w-1/2 overflow-hidden self-center">
				<div className="absolute top-0 bottom-0 left-0 w-40 bg-gradient-to-r from-white to-transparent z-10"></div>
				<Slider {...settings} className="h-full">
					{images.map((image, index) => (
						< img
							key={index}
							src={image}
							alt={`Slide ${index + 1}`}
						/>
					))}
				</Slider>
			</div >
		</section >
	);
};

export default Hero;
